import {
  SUBMIT_COMPETITOR_PROFILE_V4_REQUEST,
  SUBMIT_COMPETITOR_PROFILE_V4_SUCCESS,
  SUBMIT_COMPETITOR_PROFILE_V4_FAILURE,
} from "../actions/competitorProfileV4Actions";

const initialState = {
  loading: false,
  data: null,
  error: null,
};

const competitorProfileV4Reducer = (state = initialState, action) => {
  switch (action.type) {
    case SUBMIT_COMPETITOR_PROFILE_V4_REQUEST:
      return {
        ...state,
        loading: true,
        data: null,
        error: null,
      };
    case SUBMIT_COMPETITOR_PROFILE_V4_SUCCESS:
      return {
        ...state,
        loading: false,
        data: action.payload,
        error: null,
      };
    case SUBMIT_COMPETITOR_PROFILE_V4_FAILURE:
      return {
        ...state,
        loading: false,
        data: null,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default competitorProfileV4Reducer;
